import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

initMain([], {}, []);
header();